/* ============================================================
   BUILD A BUNDLE — behaviour
   - Category tab filtering
   - Variant popup (gallery + option pills + availability + sticky add)
   - Bundle state with per-item quantity (rows: qty + remove)
   - Tier badges light up progressively as thresholds are reached
   - Minimum-products gate on Add to cart
   - Desktop sticky sidebar / mobile compact bar + expandable sheet
   - Live cart update via the theme's cart:refresh event
   ============================================================ */
(function () {
  var mqMobile = window.matchMedia('(max-width: 989px)');

  function initRoot(root) {
    if (root.__babInit) return;
    root.__babInit = true;

    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var addLabel = root.getAttribute('data-add-label') || 'Add to bundle';
    var addedLabel = root.getAttribute('data-added-label') || 'Added';
    var selectLabel = root.getAttribute('data-select-label') || 'Select options';
    var cartLabel = root.getAttribute('data-cart-label') || 'Add to cart';
    var minProducts = parseInt(root.getAttribute('data-min'), 10) || 1;

    var tiers = [];
    try { tiers = JSON.parse(root.getAttribute('data-bab-tiers') || '[]'); } catch (e) { tiers = []; }
    tiers = tiers.filter(function (t) { return t && t.qty > 0; }).sort(function (a, b) { return a.qty - b.qty; });
    var topTier = tiers.length ? tiers[tiers.length - 1] : null;
    function saveText(t) { return t.type === 'amount' ? ('$' + t.value) : (t.value + '%'); }

    var showRating = root.getAttribute('data-show-rating') === 'true';
    var showPill = root.getAttribute('data-show-pill') === 'true';

    var bundle = {};
    var order = [];
    var openModal = null;

    /* render the star rating for a card from its data-rating JSON */
    function renderRating(card) {
      if (!showRating && !showPill) return;
      var raw = card.getAttribute('data-rating');
      var count = card.getAttribute('data-rcount');
      if (!raw || raw === 'null' || raw === '') return;
      var rating = null;
      try { var o = JSON.parse(raw); rating = parseFloat(o && o.value != null ? o.value : (o && o.rating != null ? o.rating : o)); }
      catch (e) { rating = parseFloat(raw); }
      if (!rating || rating <= 0) return;
      var pctW = Math.max(0, Math.min(100, (rating / 5) * 100));
      if (showRating) {
        var titleEl = card.querySelector('.hp-bab__title');
        if (titleEl && !card.querySelector('.hp-bab__rating')) {
          var r = document.createElement('div');
          r.className = 'hp-bab__rating';
          r.innerHTML = '<span class="hp-bab__stars" style="--pct:' + pctW + '%"><i></i></span>' + (count ? '<span class="hp-bab__rcount">(' + count + ')</span>' : '');
          titleEl.insertAdjacentElement('afterend', r);
        }
      }
      if (showPill) {
        var media = card.querySelector('.hp-bab__media');
        if (media && !media.querySelector('.hp-bab__ratingpill')) {
          var pill = document.createElement('span');
          pill.className = 'hp-bab__ratingpill';
          pill.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="m12 17.3-6.16 3.7 1.64-7-5.48-4.73 7.16-.61L12 2l2.84 6.66 7.16.61-5.48 4.73 1.64 7z"/></svg>' + rating.toFixed(1);
          media.appendChild(pill);
        }
      }
    }

    function money(cents) {
      var amount = (cents / 100).toFixed(2);
      var withComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var noDec = Math.round(cents / 100).toString();
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/g, amount)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec);
    }
    function totalQty() { var n = 0; order.forEach(function (id) { n += bundle[id].qty; }); return n; }
    function nextTier(n) { for (var i = 0; i < tiers.length; i++) { if (tiers[i].qty > n) return tiers[i]; } return null; }

    function addVariant(v, card) {
      if (!v || !v.available) return;
      if (bundle[v.id]) { bundle[v.id].qty += 1; }
      else { bundle[v.id] = { id: v.id, price: v.price, title: card.getAttribute('data-title'), variant: v.title, image: v.image || card.getAttribute('data-image') || '', qty: 1 }; order.push(v.id); }
      card.__addedId = v.id;
      renderSummary();
    }
    function setQty(id, q) { if (!bundle[id]) return; if (q <= 0) removeItem(id); else bundle[id].qty = q; renderSummary(); }
    function removeItem(id) { delete bundle[id]; order = order.filter(function (x) { return String(x) !== String(id); }); }

    /* ---------------- CARD + POPUP ---------------- */
    function initCard(card) {
      var jsonEl = card.querySelector('[data-bab-variants]');
      if (!jsonEl) return;
      var variants;
      try { variants = JSON.parse(jsonEl.textContent); } catch (e) { variants = []; }
      if (!variants.length) return;

      var mode = card.getAttribute('data-mode');
      var defaultImage = card.getAttribute('data-image') || '';
      var cta = card.querySelector('[data-bab-cta]');
      var ctaLabel = card.querySelector('[data-bab-cta-label]');
      var cardPrice = card.querySelector('[data-bab-price]');
      var cardImg = card.querySelector('.hp-bab__img');

      var def = variants.filter(function (v) { return v.available; })[0] || variants[0];
      var selected = def.options.slice();
      function currentVariant() { return variants.filter(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); })[0] || def; }
      function imgFor(v) { return (v && v.image) ? v.image : defaultImage; }

      var modal = card.querySelector('[data-bab-modal]');
      var modalPrice = modal ? modal.querySelector('[data-bab-modal-price]') : null;
      var confirmPrice = modal ? modal.querySelector('[data-bab-confirm-price]') : null;
      var confirmBtn = modal ? modal.querySelector('[data-bab-confirm]') : null;
      var availEl = modal ? modal.querySelector('[data-bab-modal-avail]') : null;
      var availText = modal ? modal.querySelector('[data-bab-avail-text]') : null;
      var slides = modal ? modal.querySelectorAll('[data-bab-slide]') : [];
      var thumbs = modal ? modal.querySelectorAll('[data-bab-mthumb]') : [];

      function setSlide(i) {
        slides.forEach(function (sl, idx) { sl.classList.toggle('is-active', idx === i); });
        thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
      }

      function updateModal() {
        var v = currentVariant();
        if (modalPrice) modalPrice.textContent = money(v.price);
        if (confirmPrice) confirmPrice.textContent = '• ' + money(v.price);
        if (availEl) {
          availEl.classList.toggle('is-out', !v.available);
          if (availText) availText.textContent = v.available ? 'In stock and ready to ship' : 'Currently unavailable';
        }
        if (confirmBtn) confirmBtn.disabled = !v.available;
        if (v.image && slides.length) { var img0 = slides[0].querySelector('img'); if (img0) img0.src = v.image; setSlide(0); }
      }
      function updateCard() { var v = currentVariant(); if (cardPrice) cardPrice.textContent = money(v.price); if (cardImg) cardImg.src = imgFor(v); }

      if (modal) {
        modal.querySelectorAll('[data-bab-optgroup]').forEach(function (group) {
          var idx = parseInt(group.getAttribute('data-opt-index'), 10);
          var vals = group.querySelectorAll('[data-bab-optval]');
          vals.forEach(function (btn) {
            if (btn.getAttribute('data-value') === selected[idx]) btn.classList.add('is-active');
            btn.addEventListener('click', function () {
              vals.forEach(function (b) { b.classList.remove('is-active'); });
              btn.classList.add('is-active');
              selected[idx] = btn.getAttribute('data-value');
              updateModal(); updateCard();
            });
          });
        });
        thumbs.forEach(function (t) { t.addEventListener('click', function () { setSlide(parseInt(t.getAttribute('data-index'), 10)); }); });
        modal.querySelectorAll('[data-bab-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
        if (confirmBtn) confirmBtn.addEventListener('click', function () { addVariant(currentVariant(), card); updateCard(); closeModal(); });
      }
      function openMd() { if (!modal) return; modal.hidden = false; openModal = modal; document.documentElement.classList.add('prevent-scroll'); updateModal(); }
      function closeModal() { if (!modal) return; modal.hidden = true; if (openModal === modal) openModal = null; document.documentElement.classList.remove('prevent-scroll'); }
      card.__closeModal = closeModal;

      cta.addEventListener('click', function () {
        if (card.__addedId && bundle[card.__addedId]) { removeItem(card.__addedId); renderSummary(); return; }
        if (mode === 'options') openMd(); else addVariant(def, card);
      });

      function syncState() {
        var added = card.__addedId && bundle[card.__addedId];
        card.classList.toggle('is-added', !!added);
        if (!ctaLabel) return;
        if (added) { ctaLabel.textContent = addedLabel; cta.disabled = false; }
        else if (mode === 'direct') { cta.disabled = !def.available; ctaLabel.textContent = def.available ? addLabel : 'Sold out'; }
        else { cta.disabled = false; ctaLabel.textContent = selectLabel; }
      }
      card.__update = syncState;
      syncState();
    }

    root.querySelectorAll('[data-bab-card]').forEach(function (c) { renderRating(c); initCard(c); });
    function syncCards() { root.querySelectorAll('[data-bab-card]').forEach(function (c) { if (c.__update) c.__update(); }); }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (openModal) { var c = openModal.closest('[data-bab-card]'); if (c && c.__closeModal) c.__closeModal(); }
      else if (sheet && !sheet.hidden) closeSheet();
    });

    /* ---------------- TABS ---------------- */
    var tabs = root.querySelectorAll('[data-bab-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
        tab.classList.add('is-active'); tab.setAttribute('aria-selected', 'true');
        var catId = tab.getAttribute('data-bab-tab');
        root.querySelectorAll('[data-bab-card]').forEach(function (c) { c.classList.toggle('is-hidden', c.getAttribute('data-category') !== catId); });
      });
    });

    /* ---------------- TIER BADGES ---------------- */
    var packsEl = root.querySelector('[data-bab-packs]');
    var packEls = [];
    function buildPacks() {
      if (!packsEl) return;
      packsEl.innerHTML = '';
      packEls = [];
      tiers.forEach(function (t) {
        var b = document.createElement('div');
        b.className = 'hp-bab__pack';
        var bdg = document.createElement('span'); bdg.className = 'hp-bab__pack-badge'; bdg.textContent = 'SAVE ' + saveText(t);
        var lbl = document.createElement('span'); lbl.className = 'hp-bab__pack-label'; lbl.textContent = t.label || ('Buy ' + t.qty);
        b.appendChild(bdg); b.appendChild(lbl);
        packsEl.appendChild(b);
        packEls.push(b);
      });
    }
    function updatePacks(count) { tiers.forEach(function (t, i) { if (packEls[i]) packEls[i].classList.toggle('is-active', count >= t.qty); }); }

    /* ---------------- SUMMARY ---------------- */
    var countEl = root.querySelector('[data-bab-count]');
    var progressEl = root.querySelector('[data-bab-progress]');
    var itemsEl = root.querySelector('[data-bab-items]');
    var totalEl = root.querySelector('[data-bab-total]');
    var hintEl = root.querySelector('[data-bab-hint]');
    var checkoutBtn = root.querySelector('[data-bab-checkout]');
    var checkoutLabel = root.querySelector('[data-bab-checkout-label]');

    var bar = root.querySelector('[data-bab-bar]');
    var barTotal = root.querySelector('[data-bab-bar-total]');
    var barLabel = root.querySelector('[data-bab-bar-label]');
    var barBtn = root.querySelector('[data-bab-bar-btn]');
    if (bar) bar.hidden = false;

    function itemsWord(n) { return n === 1 ? 'item' : 'items'; }

    function renderItems() {
      if (!itemsEl) return;
      if (!order.length) { itemsEl.className = 'hp-bab__items hp-bab__items--empty'; itemsEl.textContent = 'Your bundle is empty. Add products to get started.'; return; }
      itemsEl.className = 'hp-bab__items';
      var html = '';
      order.forEach(function (id) {
        var it = bundle[id];
        html += '<div class="hp-bab__item">' +
          '<span class="hp-bab__item-thumb" style="background-image:url(' + (it.image || '') + ')"></span>' +
          '<div class="hp-bab__item-main">' +
            '<div class="hp-bab__item-title">' + escapeHtml(it.title || '') + '</div>' +
            (it.variant && it.variant !== 'Default Title' ? '<div class="hp-bab__item-variant">' + escapeHtml(it.variant) + '</div>' : '') +
            '<div class="hp-bab__item-price">' + money(it.price) + '</div>' +
          '</div>' +
          '<div class="hp-bab__item-ctl">' +
            '<span class="hp-bab__qty"><button type="button" data-bab-qty-dec="' + it.id + '" aria-label="Decrease">−</button><span>' + it.qty + '</span><button type="button" data-bab-qty-inc="' + it.id + '" aria-label="Increase">+</button></span>' +
            '<button type="button" class="hp-bab__item-remove" data-bab-remove="' + it.id + '">Remove</button>' +
          '</div>' +
        '</div>';
      });
      itemsEl.innerHTML = html;
      itemsEl.querySelectorAll('[data-bab-qty-inc]').forEach(function (b) { b.addEventListener('click', function () { var id = b.getAttribute('data-bab-qty-inc'); setQty(id, bundle[id].qty + 1); }); });
      itemsEl.querySelectorAll('[data-bab-qty-dec]').forEach(function (b) { b.addEventListener('click', function () { var id = b.getAttribute('data-bab-qty-dec'); setQty(id, bundle[id].qty - 1); }); });
      itemsEl.querySelectorAll('[data-bab-remove]').forEach(function (b) { b.addEventListener('click', function () { removeItem(b.getAttribute('data-bab-remove')); renderSummary(); }); });
    }

    function renderSummary() {
      var count = totalQty();
      var total = 0; order.forEach(function (id) { total += bundle[id].price * bundle[id].qty; });
      var next = nextTier(count);
      var pct = topTier ? Math.min(100, Math.round((count / topTier.qty) * 100)) : (count ? 100 : 0);
      var belowMin = count < minProducts;

      var hintText = '';
      if (count > 0 && belowMin) hintText = 'Add ' + (minProducts - count) + ' more to check out';
      else if (next) hintText = 'Add ' + (next.qty - count) + ' more to save ' + saveText(next);

      renderItems();
      updatePacks(count);
      if (countEl) countEl.textContent = count + ' ' + itemsWord(count);
      if (progressEl) progressEl.style.width = pct + '%';
      if (totalEl) totalEl.textContent = money(total);
      if (hintEl) hintEl.textContent = hintText;
      if (checkoutBtn) checkoutBtn.disabled = count === 0 || belowMin;
      if (checkoutLabel) checkoutLabel.textContent = cartLabel;

      if (bar) {
        if (barTotal) barTotal.textContent = money(total);
        if (barLabel) barLabel.textContent = (count > 0 && belowMin) ? ('Add ' + (minProducts - count) + ' more') : cartLabel;
        if (barBtn) barBtn.disabled = count === 0 || belowMin;
      }
      syncCards();
    }

    /* ---------------- MOBILE SHEET + BAR DOCK ---------------- */
    var summary = root.querySelector('[data-bab-summary]');
    var summaryParent = summary ? summary.parentNode : null;
    var summaryNext = summary ? summary.nextSibling : null;
    var sheet = root.querySelector('[data-bab-sheet]');
    var sheetPanel = root.querySelector('[data-bab-sheet-panel]');

    function openSheet() { if (!mqMobile.matches || !summary || !sheetPanel) return; sheetPanel.appendChild(summary); sheet.hidden = false; document.documentElement.classList.add('prevent-scroll'); }
    function closeSheet() { if (!sheet) return; sheet.hidden = true; document.documentElement.classList.remove('prevent-scroll'); if (summary && summaryParent) summaryParent.insertBefore(summary, summaryNext); }
    root.querySelectorAll('[data-bab-bar-toggle]').forEach(function (el) { el.addEventListener('click', openSheet); });
    root.querySelectorAll('[data-bab-sheet-close]').forEach(function (el) { el.addEventListener('click', closeSheet); });
    mqMobile.addEventListener('change', function () { if (!mqMobile.matches) closeSheet(); });

    var endEl = root.querySelector('[data-bab-end]');
    if (endEl && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { root.classList.toggle('hp-bab--bar-docked', e.isIntersecting); if (bar) bar.classList.toggle('is-docked', e.isIntersecting); });
      }, { rootMargin: '0px 0px -40px 0px' }).observe(endEl);
    }

    /* ---------------- ADD TO CART (live refresh) ---------------- */
    var busy = false;
    function checkout() {
      if (busy || order.length === 0 || totalQty() < minProducts) return;
      busy = true;
      var items = order.map(function (id) { return { id: parseInt(id, 10), quantity: bundle[id].qty, properties: { _bundle: 'hydro' } }; });
      var routes = (window.MinimogSettings && MinimogSettings.routes) || {};
      var addUrl = (routes.cart_add_url || '/cart/add') + '.js';
      fetch(addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { closeSheet(); document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } })); busy = false; })
        .catch(function () { busy = false; window.location.href = (routes.cart || '/cart'); });
    }
    if (checkoutBtn) checkoutBtn.addEventListener('click', checkout);
    if (barBtn) barBtn.addEventListener('click', checkout);

    buildPacks();
    renderSummary();
  }

  function escapeHtml(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function initAll() { document.querySelectorAll('[data-bab-root]').forEach(initRoot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
